import * as ProcessWFMStatusHistoricACtions from '@actions/process-wfmstatus-historic/process-wfmstatus-historic.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { RealtimeGatewayService } from '@services/index';
import { RealTimeNotify } from '@models/index';


@Injectable()
export class ProcessWFMStatusHistoricEffects {

  constructor(private actions$: Actions, private realtimeGatewayService: RealtimeGatewayService) { }

  getNotifyProcessWFMStatusHistoric$ = createEffect(() => this.actions$.pipe(
    ofType(ProcessWFMStatusHistoricACtions.GetNotifyProcessWFMStatusHistoric),
    switchMap((action) => this.realtimeGatewayService.observe(action.equipmentId, action.commandTypeId).pipe(
      catchError((err) => of(
        ProcessWFMStatusHistoricACtions.GetNotifyProcessWFMStatusHistoricFailure({ error: err })
        )
      ),
      mergeMap((data: RealTimeNotify) => [
        ProcessWFMStatusHistoricACtions.GetNotifyProcessWFMStatusHistoricSuccess({ data }),
        ProcessWFMStatusHistoricACtions.GetProcessWFMStatusHistoric({ ...data })
      ],
      ),
    ),
    )
  ));

  getProcessWFMStatusHistoric$ = createEffect(() => this.actions$.pipe(
    ofType(ProcessWFMStatusHistoricACtions.GetProcessWFMStatusHistoric),
    mergeMap((action) => this.realtimeGatewayService.getDocument(action.equipmentId, action.commandTypeId).pipe(
      map((data) => ProcessWFMStatusHistoricACtions.GetProcessWFMStatusHistoricSuccess({ data:{ data, equipmentId: action.equipmentId} }),
      ),
      catchError((err) => of(ProcessWFMStatusHistoricACtions.GetProcessWFMStatusHistoricFailure({ error: err })))
    ))
  ));

}
